export default function TeamSection() {
  return (
    <section className="py-8 md:py-14 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-center">
          <div className="flex-1 w-full">
            <p className="text-xs md:text-sm text-primary-600 font-medium mb-2 uppercase tracking-wider">Equipo local</p>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading leading-tight">
              Un equipo de Málaga, una flota profesional a tu servicio
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-5 md:mb-6 leading-relaxed">
              Nuestros técnicos llegan a tu domicilio con todo el equipamiento necesario. Sin demoras, sin subcontratas. Más de 10 años conociendo Málaga barrio a barrio, desde el Centro Histórico hasta Campanillas.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3">
              <div className="flex items-center gap-3 p-2.5 md:p-3 bg-background-50 rounded-xl border border-background-200/60">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                  <span className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"><i className="ri-truck-line text-primary-600 text-xs md:text-sm"></i></span>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-800">Flota de vehículos equipados</span>
              </div>
              <div className="flex items-center gap-3 p-2.5 md:p-3 bg-background-50 rounded-xl border border-background-200/60">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                  <span className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"><i className="ri-team-line text-primary-600 text-xs md:text-sm"></i></span>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-800">Técnicos en plantilla, sin subcontratas</span>
              </div>
              <div className="flex items-center gap-3 p-2.5 md:p-3 bg-background-50 rounded-xl border border-background-200/60">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                  <span className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"><i className="ri-time-line text-primary-600 text-xs md:text-sm"></i></span>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-800">Servicio urgente 24/7 en Málaga</span>
              </div>
              <div className="flex items-center gap-3 p-2.5 md:p-3 bg-background-50 rounded-xl border border-background-200/60">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-accent-500/15 flex-shrink-0">
                  <span className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"><i className="ri-tools-line text-accent-600 text-xs md:text-sm"></i></span>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-800">Todas las herramientas a bordo</span>
              </div>
            </div>
          </div>
          <div className="w-full md:w-[48%] h-48 sm:h-72 md:h-80 rounded-2xl overflow-hidden flex-shrink-0">
            <img
              alt="Flota profesional de vehículos de servicio en Málaga"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/c4d2409e59ee907027d8c7403faa97d2.webp"
            />
          </div>
        </div>
      </div>
    </section>
  );
}